import { FormInput } from "@/shared/ui/form-input"
import { UseFormRegister, FieldErrors } from "react-hook-form"
import { IContactPerson, VerificationStatus } from "@/shared/api/onboarding"

type ContactForm = {
    full_name: string
    position: string
    phone: string
    email: string
}

interface ContactPersonProps {
    register: UseFormRegister<ContactForm>
    errors: FieldErrors<ContactForm>
    isSaving: boolean
    isSubmitting: boolean
    isContactComplete: boolean
    canSubmit: boolean
    onSubmit: () => void
    onSubmitForModeration: () => void
}

export const ContactPerson = ({
    register,
    errors,
    isSaving,
    isSubmitting,
    isContactComplete,
    canSubmit,
    onSubmit,
    onSubmitForModeration
}: ContactPersonProps) => {
    return (
        <div className="box">
            <div className="box_header font-mediumttf !mb-4">
                Контактное лицо
            </div>
            <form onSubmit={onSubmit} className="flex flex-col gap-6">
                <FormInput 
                    error={errors.full_name}
                    placeholder="Введите ФИО"
                    register={register as any}
                    label="ФИО" 
                    id="full_name" 
                    required
                />
                <FormInput 
                    error={errors.position}
                    placeholder="Введите должность"
                    register={register as any}
                    label="Должность" 
                    id="position" 
                    required
                />
                <FormInput 
                    error={errors.phone}
                    placeholder="Введите телефон"
                    register={register as any}
                    label="Телефон" 
                    id="phone" 
                    required
                />
                <FormInput 
                    error={errors.email}
                    placeholder="Введите email"
                    register={register as any}
                    label="Электронная почта" 
                    type="email"
                    id="email" 
                    required
                />
                <div className="flex gap-4">
                    <button 
                        type="submit" 
                        disabled={isSaving || isSubmitting}
                        className="text-[22px] text-white justify-center inline-flex gap-2 px-8 text-center bg-color-dark rounded-full py-3 disabled:opacity-50 disabled:cursor-not-allowed"
                    >
                        {isSaving ? 'Сохранение...' : 'Сохранить'}
                    </button>
                    <button 
                        type="button"
                        onClick={onSubmitForModeration}
                        disabled={isSaving || isSubmitting || !isContactComplete || !canSubmit}
                        className="text-[22px] text-white justify-center inline-flex gap-2 px-8 text-center bg-color-primary rounded-full py-3 disabled:opacity-50 disabled:cursor-not-allowed"
                    >
                        {isSubmitting ? 'Отправка...' : 'Отправить на модерацию'}
                    </button>
                </div>
            </form>
        </div>
    )
}

